module.exports = __webpack_public_path__ + "img/მაია.6dd1cc2e.png";